'use client';

import React, { useEffect, useRef, useState } from 'react';

interface Review {
  initials: string;
  name: string;
  text: string;
  stagger: number;
}

const reviews: Review[] = [
  {
    initials: 'HK',
    name: 'Haris Kajevic',
    text: 'Top Buchhaltungsbüro im Raum Limburg! Läuft alles komplett digital, unkompliziert und zuverlässig. Buchhaltung, Lohnabrechnung, BWA – wird alles pünktlich und sauber erledigt. Klare Kommunikation, kein Papierchaos! Sehr vertrauenswürdig und absolut empfehlenswert!',
    stagger: 1,
  },
  {
    initials: 'CG',
    name: 'Carsten Gräser',
    text: 'Ich bin seit geraumer Zeit beim Aktas Buchhaltungsservice und könnte nicht zufriedener sein. Herr Aktas zeichnet sich durch eine enorme Fachkompetenz und absolute Zuverlässigkeit aus. In der Welt der Zahlen braucht man jemanden, dem man blind vertrauen kann – und hier ist man an der richtigen Adresse. Jede Abrechnung ist fehlerfrei und termingerecht. Herr Aktas erklärt auch komplexe Sachverhalte verständlich und nimmt sich Zeit für individuelle Fragen. Die Zusammenarbeit verläuft digital und extrem effizient. Wer einen Buchhaltungsservice sucht, der einem wirklich den Rücken freihält, ist hier genau richtig. Klare Empfehlung!',
    stagger: 2,
  },
  {
    initials: 'VD',
    name: 'Vanessa Drews',
    text: 'Ich arbeite nun seit einiger Zeit mit Herrn Aktas zusammen und möchte an dieser Stelle meine durchweg positiven Erfahrungen teilen. Besonders schätze ich seine Zuverlässigkeit und das vertrauensvolle Verhältnis, das sich daraus entwickelt hat – etwas, das man heute nicht mehr bei jedem Dienstleister findet. Herr Aktas ist außerordentlich hilfsbereit und verfügt über eine beeindruckende Expertise, auch wenn es um detaillierte oder komplexere Fragen rund um die GmbH geht. Und selbst in den seltenen Fällen, in denen er eine Information nicht sofort parat hat, holt er diese zuverlässig ein und meldet sich zeitnah zurück. Ich freue mich auf viele weitere Jahre der Zusammenarbeit mit Herrn Aktas und kann ihn uneingeschränkt weiterempfehlen.',
    stagger: 3,
  },
  {
    initials: 'SW',
    name: 'Sabine Wittlich',
    text: 'Ich arbeite jetzt mit Herrn Aktas schon eine Zeit lang zusammen. Er ist sehr zuverlässig und gewissenhaft. Ich kann ihn uneingeschränkt empfehlen. Er arbeitet strukturiert und gibt die Unterlagen immer pünktlich ab.',
    stagger: 1,
  },
  {
    initials: 'SS',
    name: 'Steve Sittinger',
    text: 'Sehr guter Buchhalter, hilft wenn ich ein Problem oder Fragen habe. Würde ihn immer weiterempfehlen 🙏',
    stagger: 2,
  },
  {
    initials: 'HS',
    name: 'Hannisch Shop',
    text: 'Herr Aktas hat einen sehr schweren Fall übernommen. Da meine ehemalige Steuerberaterin sich nicht richtig um meine Angelegenheiten gekümmert hat, waren unsere Steuererklärungen für die letzten beiden Jahre noch gar nicht beim Finanzamt eingereicht. Herr Aktas hat sich sehr schnell darum gekümmert. Er antwortet schnell, wenn man eine Frage hat und ist sehr zuverlässig.',
    stagger: 3,
  },
];

const CARDS_PER_PAGE = 3;
const TOTAL_PAGES = Math.ceil(reviews.length / CARDS_PER_PAGE);

const StarIcon = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" style={{ color: 'var(--accent)' }}>
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
  </svg>
);

const GoogleIcon = () => (
  <svg className="w-5 h-5 opacity-30" viewBox="0 0 24 24" fill="none">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" />
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
  </svg>
);

function ReviewCard({ review, hovered, onMouseEnter, onMouseLeave }: { review: Review; hovered: boolean; onMouseEnter: () => void; onMouseLeave: () => void }) {
  return (
    <div
      className="rounded-2xl p-6 md:p-8 border transition-all duration-300 flex flex-col gap-4 h-full"
      style={{
        backgroundColor: 'rgba(255,255,255,0.05)',
        borderColor: hovered ? 'rgba(200,150,90,0.4)' : 'rgba(200,150,90,0.25)',
        transform: hovered ? 'translateY(-4px)' : 'translateY(0)',
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {/* Header */}
      <div className="flex items-center gap-3">
        <div
          className="w-10 h-10 rounded-full border flex items-center justify-center font-bold text-sm flex-shrink-0"
          style={{ backgroundColor: 'rgba(200,150,90,0.2)', borderColor: 'rgba(200,150,90,0.3)', color: 'var(--accent)' }}
        >
          {review.initials}
        </div>
        <div className="min-w-0">
          <p className="text-sm font-semibold truncate" style={{ color: 'var(--primary-foreground)' }}>{review.name}</p>
          <div className="mt-0.5 flex gap-0.5">
            {[...Array(5)].map((_, i) => <StarIcon key={i} />)}
          </div>
        </div>
        <div className="ml-auto flex-shrink-0">
          <GoogleIcon />
        </div>
      </div>

      {/* Text */}
      <div className="flex-1">
        <p className="text-sm leading-relaxed font-light" style={{ color: 'rgba(247,245,242,0.7)' }}>
          {review.text}
        </p>
      </div>

      {/* Footer */}
      <div className="mt-auto pt-2 border-t flex items-center gap-1.5" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
        <span className="text-xs" style={{ color: 'rgba(247,245,242,0.3)' }}>Google Bewertung</span>
      </div>
    </div>
  );
}

export default function TestimonialsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [page, setPage] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [animating, setAnimating] = useState(false);
  const [direction, setDirection] = useState<'left' | 'right'>('right');

  const prevPage = () => {
    if (animating) return;
    setDirection('left');
    setAnimating(true);
    setTimeout(() => {
      setPage((p) => (p - 1 + TOTAL_PAGES) % TOTAL_PAGES);
      setAnimating(false);
    }, 200);
  };

  const nextPage = () => {
    if (animating) return;
    setDirection('right');
    setAnimating(true);
    setTimeout(() => {
      setPage((p) => (p + 1) % TOTAL_PAGES);
      setAnimating(false);
    }, 200);
  };

  const currentReviews = reviews.slice(page * CARDS_PER_PAGE, page * CARDS_PER_PAGE + CARDS_PER_PAGE);

  // Mobile: single card index within full list
  const [mobileIndex, setMobileIndex] = useState(0);
  const mobilePrev = () => setMobileIndex((i) => (i - 1 + reviews.length) % reviews.length);
  const mobileNext = () => setMobileIndex((i) => (i + 1) % reviews.length);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.scroll-reveal-init');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="py-16 md:py-32 px-5 md:px-10 overflow-hidden relative"
      style={{ backgroundColor: 'var(--primary)', color: 'var(--primary-foreground)' }}
      ref={sectionRef}
    >
      {/* Background decorations */}
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute top-0 right-0 w-1/2 h-full opacity-5"
          style={{ background: 'radial-gradient(ellipse at top right, rgba(200,150,90,1) 0%, transparent 60%)' }}
        />
        <div
          className="absolute inset-y-0 left-1/2 -translate-x-1/2 flex items-center pointer-events-none select-none overflow-hidden w-full"
          style={{
            WebkitMaskImage: 'linear-gradient(90deg, transparent, black 20%, black 80%, transparent)',
            maskImage: 'linear-gradient(90deg, transparent, black 20%, black 80%, transparent)',
          }}
        >
          <span
            className="font-display font-bold whitespace-nowrap tracking-tighter leading-none"
            style={{ color: 'rgba(255,255,255,0.04)', fontSize: 'clamp(4rem, 12vw, 14rem)' }}
          >
            Vertrauen &amp; Kompetenz
          </span>
        </div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="mb-12 md:mb-20 scroll-reveal-init">
          <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] mb-5" style={{ color: 'var(--accent)' }}>
            <span className="gold-dot" />
            Rezensionen unserer Mandanten
          </span>
          <h2 className="font-display text-hero-sm font-semibold text-balance max-w-2xl" style={{ color: 'var(--primary-foreground)' }}>
            Warum Mandanten uns{' '}
            <span className="italic" style={{ color: 'var(--accent)' }}>vertrauen</span>
          </h2>
        </div>

        {/* Carousel */}
        <div className="scroll-reveal-init stagger-1">
          {/* Desktop: show 3 cards per page, all equally highlighted */}
          <div
            className="hidden md:grid md:grid-cols-3 gap-4 md:gap-6 transition-opacity duration-200"
            style={{ opacity: animating ? 0 : 1 }}
          >
            {currentReviews.map((review, idx) => (
              <ReviewCard
                key={review.name}
                review={review}
                hovered={hoveredIndex === idx}
                onMouseEnter={() => setHoveredIndex(idx)}
                onMouseLeave={() => setHoveredIndex(null)}
              />
            ))}
          </div>

          {/* Mobile: show one at a time across all 6 */}
          <div className="md:hidden">
            <ReviewCard
              review={reviews[mobileIndex]}
              hovered={hoveredIndex === mobileIndex}
              onMouseEnter={() => setHoveredIndex(mobileIndex)}
              onMouseLeave={() => setHoveredIndex(null)}
            />
          </div>

          {/* Navigation — desktop uses page navigation, mobile uses full list */}
          <div className="flex items-center justify-center gap-6 mt-8">
            <button
              onClick={() => { prevPage(); mobilePrev(); }}
              aria-label="Vorherige Rezensionen"
              className="w-11 h-11 rounded-full border flex items-center justify-center transition-all duration-200 hover:scale-105"
              style={{
                borderColor: 'rgba(200,150,90,0.4)',
                backgroundColor: 'rgba(200,150,90,0.1)',
                color: 'var(--accent)',
              }}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            {/* Dots — desktop: 2 pages, mobile: 6 dots */}
            <div className="hidden md:flex gap-2">
              {Array.from({ length: TOTAL_PAGES }).map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setPage(idx)}
                  aria-label={`Seite ${idx + 1}`}
                  className="w-2 h-2 rounded-full transition-all duration-200"
                  style={{
                    backgroundColor: idx === page ? 'var(--accent)' : 'rgba(200,150,90,0.3)',
                    transform: idx === page ? 'scale(1.3)' : 'scale(1)',
                  }}
                />
              ))}
            </div>
            <div className="flex md:hidden gap-2">
              {reviews.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setMobileIndex(idx)}
                  aria-label={`Rezension ${idx + 1}`}
                  className="w-2 h-2 rounded-full transition-all duration-200"
                  style={{
                    backgroundColor: idx === mobileIndex ? 'var(--accent)' : 'rgba(200,150,90,0.3)',
                    transform: idx === mobileIndex ? 'scale(1.3)' : 'scale(1)',
                  }}
                />
              ))}
            </div>

            <button
              onClick={() => { nextPage(); mobileNext(); }}
              aria-label="Nächste Rezensionen"
              className="w-11 h-11 rounded-full border flex items-center justify-center transition-all duration-200 hover:scale-105"
              style={{
                borderColor: 'rgba(200,150,90,0.4)',
                backgroundColor: 'rgba(200,150,90,0.1)',
                color: 'var(--accent)',
              }}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
